<template>
<div class="row">
  
  <div class="col-12 mb-4" v-if="(consulta && consulta.tipo_status && consulta.tipo_status.id == 66) || (formData.tipo_status && formData.tipo_status.id == 66)">
      <ed-alert

        type="success"
        :description="'Essa consulta foi LIBERADA em '+formData.updated_at"
        title="Atenção"
      />
  </div>

  <div class="col-12 mb-4" v-else-if="(consulta && consulta.tipo_status && (consulta.tipo_status.id == 57 || consulta.tipo_status.id == 58))">
      <ed-alert
        type="error"
        :description="'Essa consulta foi '+consulta.tipo_status.descricao+' em '+toDate(consulta.updated_at)+'. Nenhuma alteração pode ser efetuada.'"
        title="Atenção"
      />

      <div class="col-12 mt-4 text-center">
        <ed-button
          icon="fa fa-arrow-left"
          type="primary"
          value="Voltar"
          @click="toRoute({name:'credenciada.consulta'})"
        />
      </div>
  </div>
  
  <div class="col-12 mb-2" v-loading="config.loading.content" v-else>
    <ed-form :data="formData" :config="config" :itens="formItems" :response="response">
      <div slot="form-footer"></div>
    </ed-form>

    <div class="col-12 text-center">
      <ed-button
        icon="fa fa-print"
        type="success"
        title="Clique Aqui para salvar as alterações efetuadas"
        value="Salvar Alterações"
        @click="salvar"
      />
    </div>

  </div>

</div>
</template>

<script>
import Rest from 'common/rest'
import EdAlert from 'common/alert'
import EdForm from 'common/form'
import EdButton from 'common/button'
import FormItems from '../_form/consulta-config-liberacao'

export default {
    name: 'aso',
    components:{EdAlert,EdForm,EdButton},
    mixins:[Rest],
    props:{
      consulta:{
        type: Object,
        default: {}
      }
    },
    watch:{
      'consulta.id'(){
        this.getConsulta()
      },
      'consulta.tipo_status.id'(){
      },
      'formData.aptidao'(){
				this.handleAptidao();
			}
    },
    data () {
      return{
        config:{
          tipo:[53,185,189],
          tipo_exclude:[54,55,68,56,57,58,69],
          click:{
            exames:this.getExame
          },
          list:{
            exames:[],
          },
					loading:{
						save:false,
						table:false,
            content:false,
            exames:false,
					},
					disabled:{
						id_tipo_status:false,
						te_alt:false,
            te_esp:false,
            exames:false,
						obs:false,
					}
				},
        response:{
        },
        formData:{
          id:0,
          id_tipo_status:'69',
          tipo_status:null,
					aptidao:null,
					te_alt:null,
					te_esp:null,
					te_ele:null,
					obs:null,
          senha:null,
          arquivo_aso:null,
          arquivo_femo:null,
          arquivo_exame:null,
          updated_at:null,
          exames:[],
        },
        formItems:[],
      }
    },

    created(){
    },
    mounted(){
      this.formItems = FormItems;
      this.getConsulta();

      this.$events.on('upload-arquivo_aso', eventData => {
        this.formData.arquivo_aso = eventData;
      });

      this.$events.on('upload-arquivo_femo', eventData => {
        this.formData.arquivo_femo = eventData;
      });

      this.$events.on('upload-arquivo_exame', eventData => {
        this.formData.arquivo_exame = eventData;
      });
    },

    methods: {

      handleAptidao(){

				this.config.disabled.id_tipo_status = (this.formData.aptidao == '2' || this.formData.aptidao == '5');
				this.config.disabled.te_alt = (this.formData.aptidao == '5');
        this.config.disabled.te_esp = (this.formData.aptidao == '5');
        
				if(this.formData.aptidao == '2'){
					this.formData.id_tipo_status = '67';
				}
				else if(this.formData.aptidao == '5'){
					this.formData.id_tipo_status = '70';
        }
        else if(this.formData.aptidao == '1'){
					this.formData.id_tipo_status = '66';
				}
      },
      
      getExame(search){
        
      },

      getConsulta(){

        if(!this.consulta || !this.consulta.id)return;

        this.config.loading.content = true;
        this.tabSelected = 'tab-aso';
        this.response = {};

        this.get("consulta/"+this.consulta.id_con).then(result =>{

          result = result[0];

          this.response = result;

          this.config.loading.content = false;
          this.config.list.exames = [];

          if(result.status == 200){
            this.formData = {
              id_tipo_status:'66',
              tipo_status:result.data.tipo_status,
							aptidao:(this.toString(result.data.aptidao) == '0' ? null : this.toString(result.data.aptidao)),
							te_alt:(this.toString(result.data.te_alt) == '0' ? null : this.toString(result.data.te_alt)),
							te_alt:(this.toString(result.data.te_alt) == '0' ? null : this.toString(result.data.te_alt)),
							te_esp:(this.toString(result.data.te_esp) == '0' ? null : this.toString(result.data.te_esp)),
              updated_at:(result.data.updated_at ? this.toDate(result.data.updated_at) : null),
              obs:result.data.obs,
							exames:[],
              senha:null,
              arquivo_aso:null,
              arquivo_femo:null,
              arquivo_exame:null,
            };
            
            for (let i = 0; i <  result.data.exames.length; i++) {
              const element = result.data.exames[i];

              if(element.dem == 0){
                this.config.list.exames.push(element.exame);
              }
            }
          }
        });
      },

      salvar: function(){

				this.$confirm('Ao inserir uma NOVA LIBERAÇÃO não será possível desfazer a ação. Deseja prosseguir?', 'Atenção', {
				type: 'warning'
				})
				.then(() => {

					this.config.loading.save = true;
					this.response = {};

					this.post('consulta/liberacao/'+this.consulta.id_con+'/cadastrar',this.toFormUpload(this.formData)).then((result)=>{

						result = result[0];
						this.response = result;

						this.config.loading.save = false;

						if(result.status == 200){
							this.edMsg('Liberação cadastrado com sucesso!');
              this.getConsulta();
              this.$events.fire('consulta-liberado');
						}

					});
				});
      }
      
    }
}
</script>


// WEBPACK FOOTER //
// liberar.vue?452f0f33